/* eslint-disable import/no-mutable-exports */
import axios from 'axios';
import { menubar } from './menu';
import Utils from './utils';

const bodyElement = document.querySelector('body');
// const smBreakPoint = '(max-width: 640px)';
// const smMq = window.matchMedia(smBreakPoint);

const keyCode = Object.freeze({
	TAB: 9,
	RETURN: 13,
	ESC: 27,
	SPACE: 32,
	PAGEUP: 33,
	PAGEDOWN: 34,
	END: 35,
	HOME: 36,
	LEFT: 37,
	UP: 38,
	RIGHT: 39,
	DOWN: 40,
});

class Dialog {
	constructor(dialogId, focusAfterClosed, focusFirst, nested, onClose, onOpen) {
		this.utils = new Utils();
		this.dialogNode = document.querySelector(dialogId);
		this.dialogCloseNodes = this.dialogNode.querySelectorAll('.modal-close');
		this.handleTrapFocus = this.trapFocus.bind(this);
		this.nested = nested;
		this.onOpen = onOpen;
		this.onClose = onClose;

		if (this.dialogNode === null) {
			throw new Error(`No element found with id="${dialogId}".`);
		}

		const validRoles = ['dialog', 'alertdialog'];
		const isDialog = (this.dialogNode.getAttribute('role') || '')
			.trim()
			.split(/\s+/g)
			.some(function (token) {
				return validRoles.some(function (role) {
					return token === role;
				});
			});
		if (!isDialog) {
			throw new Error('Dialog() requires a DOM element with ARIA role of dialog or alertdialog.');
		}

		this.backdropNode = this.dialogNode.parentNode;
		this.backdropNode.classList.add('is-visible');
		if (this.backdropNode.classList.contains('map-popup-overlay')) {
			setTimeout(() => {
				this.backdropNode.classList.add('slide-animation');
			}, 1);
		}
		bodyElement.classList.add('overflow-hidden');
		this.dialogNode.setAttribute('aria-hidden', false);
		this.onOpen && this.onOpen();

		if (!nested) {
			if (typeof focusAfterClosed === 'string') {
				this.focusAfterClosed = document.querySelector(focusAfterClosed);
			} else if (typeof focusAfterClosed === 'object') {
				this.focusAfterClosed = focusAfterClosed;
			} else {
				throw new Error('the focusAfterClosed parameter is required for the aria.Dialog constructor.');
			}

			if (typeof focusFirst === 'string') {
				this.focusFirst = this.dialogNode.querySelector(focusFirst);
			} else if (typeof focusFirst === 'object') {
				this.focusFirst = focusFirst;
			} else {
				this.focusFirst = null;
			}
		}

		const preDiv = document.createElement('div');
		this.preNode = this.dialogNode.parentNode.insertBefore(preDiv, this.dialogNode);
		this.preNode.tabIndex = 0;
		const postDiv = document.createElement('div');
		this.postNode = this.dialogNode.parentNode.insertBefore(postDiv, this.dialogNode.nextSibling);
		this.postNode.tabIndex = 0;

		if (this.openDialog) {
			this.openDialog.removeListeners();
		}

		this.addListeners();
		this.openDialog = this;
		// this.clearDialog();

		if (!nested) {
			if (this.focusFirst) {
				this.focusFirst.focus();
				this.dialogNode.scrollTop = 0;
			} else {
				this.utils.focusFirstDescendant(this.dialogNode);
				this.dialogNode.scrollTop = 0;
			}
		}

		this.lastFocus = document.activeElement;
	}

	get getOpenDialog() {
		return this.openDialog;
	}

	// eslint-disable-next-line class-methods-use-this, prettier/prettier
	// clearDialog() {}

	close() {
		this.openDialog = null;
		this.removeListeners();
		this.dialogNode.parentNode.removeChild(this.preNode);
		this.dialogNode.parentNode.removeChild(this.postNode);
		if (this.backdropNode.classList.contains('map-popup-overlay')) {
			this.backdropNode.classList.remove('slide-animation');
			setTimeout(() => {
				this.backdropNode.classList.remove('is-visible');
				this.onClose && this.onClose();
			}, 400);
		} else {
			this.backdropNode.classList.remove('is-visible');
			this.onClose && this.onClose();
		}
		bodyElement.classList.remove('overflow-hidden');
		this.dialogNode.setAttribute('aria-hidden', true);
		if (!this.nested) {
			this.focusAfterClosed.focus();
		}
	}

	addListeners() {
		if (!this.nested) {
			document.addEventListener('focus', this.handleTrapFocus, true);
		}
		if (this.dialogCloseNodes.length) {
			this.dialogCloseNodes.forEach((el) => {
				el.addEventListener('click', this.handleCloseClick.bind(this), true);
				el.addEventListener('keydown', this.handleCloseKeydown.bind(this), true);
			});
		}
		// window.addEventListener('resize', this.handleWindowResize.bind(this));
	}

	removeListeners() {
		if (!this.nested) {
			document.removeEventListener('focus', this.handleTrapFocus, true);
		}
	}

	trapFocus(event) {
		if (this.utils.getIgnoreUtilFocusChanges) {
			return;
		}
		const currentDialog = this.openDialog;

		if (currentDialog.dialogNode.contains(event.target)) {
			currentDialog.lastFocus = event.target;
		} else {
			this.utils.focusFirstDescendant(currentDialog.dialogNode);
			if (currentDialog.lastFocus === document.activeElement) {
				this.utils.focusLastDescendant(currentDialog.dialogNode);
			}
			currentDialog.lastFocus = document.activeElement;
		}
	}

	handleCloseClick(event) {
		const target = event.currentTarget;
		if (!target.classList.contains('hyperlink')) {
			event.preventDefault();
			event.stopPropagation();
		}
		if (this.openDialog) {
			this.openDialog.close();
		}
	}

	handleCloseKeydown(event) {
		let flag = false;

		switch (event.keyCode) {
			case keyCode.SPACE:
			case keyCode.RETURN:
				if (this.openDialog) {
					this.openDialog.close();
				}
				flag = true;
				break;
			default:
				break;
		}

		if (flag) {
			event.stopPropagation();
			event.preventDefault();
		}
	}

	// eslint-disable-next-line class-methods-use-this, prettier/prettier
	// handleWindowResize() {}
}

const alertModalContainer = document.querySelector('.alert-notification-modal-overlay');
const ppdAlertModalContainer = document.querySelector('.ppd-alert-notification-modal-overlay');
const authorModalContainer = document.querySelector('.author-notification-modal-overlay');
const specialOfferModalContainer = document.querySelector('.special-offer-modal-overlay');
const contentModalContainer = document.querySelector('.content-modal-overlay');
const featuredHotelModalContainer = document.querySelector('.featured-hotel-modal-overlay');
const holidayOfferModalContainer = document.querySelector('.holiday-offer-modal-overlay');
const taMenuModalContainer = document.querySelector('.ta-menu-modal-overlay');
const openModalContrs = document.querySelectorAll('.js-open-modal');
let targetModalObj = null;

const mediaBreakPoint = '(min-width: 768px)';
const mq = window.matchMedia(mediaBreakPoint);
const largeMediaBreakPoint = '(min-width: 1600px)';
const largeMq = window.matchMedia(largeMediaBreakPoint);

const fetchHotelDataResults = (value) => {
	return new Promise((resolve) => {
		const url = `/assets/components/canadianaffair/getHotel.php?hotel=${value}`;

		axios
			.get(url)
			.then((response) => {
				resolve(response.data);
			})
			.catch((error) => {
				console.error(error);
			});
	});
};

const initDialog = (modalContr) => {
	let targetModalId = modalContr.dataset.target;

	if (modalContr.tagName === 'BODY') {
		const lastVisit = localStorage.getItem('alert');

		if (!lastVisit || new Date() - new Date(lastVisit) > 24 * 60 * 60 * 1000) {
			window.addEventListener('DOMContentLoaded', function (eve) {
				if (targetModalId === '#headerAlertModal' && !document.querySelector('#headerAlertModal')) {
					const tplAlertModal = document.getElementById('headerAlertModalTpl') ? document.getElementById('headerAlertModalTpl').content : null;
					const alertModalNode = tplAlertModal.cloneNode(true);
					alertModalContainer.appendChild(alertModalNode);
				}

				targetModalObj = new Dialog(targetModalId, this, 'a', false, () => {
					// close function
					document.querySelector('#headerAlertModal').remove();
					localStorage.setItem('alert', new Date());
				});
			});
		}
	} else {
		modalContr.addEventListener('click', function (eve) {
			eve.preventDefault();

			if ((!targetModalId || targetModalId === '') && modalContr.classList.contains('js-modal-fixed')) {
				targetModalId = '#contentModal';
				const tplContentModal = document.getElementById('contentModalTpl') ? document.getElementById('contentModalTpl').content : null;
				const contentModalNode = tplContentModal.cloneNode(true);
				contentModalContainer.appendChild(contentModalNode);
			}

			if (targetModalId === '#authorModal' && !document.querySelector('#authorModal')) {
				const tplAuthorModal = document.getElementById('authorModalTpl') ? document.getElementById('authorModalTpl').content : null;
				const authorModalNode = tplAuthorModal.cloneNode(true);
				authorModalContainer.appendChild(authorModalNode);
			}

			if (targetModalId === '#specialOfferModal' && !document.querySelector('#specialOfferModal')) {
				const tplSpecialOfferModal = document.getElementById('specialOfferModalTpl') ? document.getElementById('specialOfferModalTpl').content : null;
				const specialOfferModalNode = tplSpecialOfferModal.cloneNode(true);
				specialOfferModalContainer.appendChild(specialOfferModalNode);
			}

			if (targetModalId === '#headerAlertModal' && !document.querySelector('#headerAlertModal')) {
				const tplAlertModal = document.getElementById('headerAlertModalTpl') ? document.getElementById('headerAlertModalTpl').content : null;
				const alertModalNode = tplAlertModal.cloneNode(true);
				alertModalContainer.appendChild(alertModalNode);
			}

			if (targetModalId === '#ppdAlertModal' && !document.querySelector('#ppdAlertModal')) {
				const ppdTplAlertModal = document.getElementById('ppdAlertModalTpl') ? document.getElementById('ppdAlertModalTpl').content : null;
				const ppdAlertModalNode = ppdTplAlertModal.cloneNode(true);
				ppdAlertModalContainer.appendChild(ppdAlertModalNode);

				// hide trigger on open
				modalContr.style.display = 'none';
			}

			if (targetModalId === '#featuredHotelModal' && !document.querySelector('#featuredHotelModal')) {
				const tplFeaturedHotelModal = document.getElementById('featuredHotelModalTpl') ? document.getElementById('featuredHotelModalTpl').content : null;
				const featuredHotelModalNode = tplFeaturedHotelModal.cloneNode(true);
				featuredHotelModalContainer.appendChild(featuredHotelModalNode);
			}

			if (targetModalId === '#holidayOfferModal' && !document.querySelector('#holidayOfferModal')) {
				const tplHolidayOfferModal = document.getElementById('holidayOfferModalTpl') ? document.getElementById('holidayOfferModalTpl').content : null;
				const holidayOfferModalNode = tplHolidayOfferModal.cloneNode(true);
				holidayOfferModalContainer.appendChild(holidayOfferModalNode);
			}

			if (targetModalId === '#specialOfferModal') {
				const contentEl = specialOfferModalContainer.querySelector('#specialOffeContent');

				targetModalObj = new Dialog(
					targetModalId,
					this,
					'a',
					false,
					() => {
						contentEl.innerHTML = '';
					},
					() => {
						const termsText = modalContr.dataset.terms;
						contentEl.innerHTML = termsText;
					}
				);
			} else if (targetModalId === '#headerAlertModal') {
				targetModalObj = new Dialog(targetModalId, this, 'a', false, () => {
					document.querySelector('#headerAlertModal').remove();
				});
			} else if (targetModalId === '#ppdAlertModal') {
				targetModalObj = new Dialog(targetModalId, this, 'a', false, () => {
					document.querySelector('#ppdAlertModal').remove();

					// show trigger on close
					modalContr.style.display = '';
				});
			} else if (targetModalId === '#contentModal') {
				targetModalObj = new Dialog(targetModalId, this, 'a', false, () => {
					document.querySelector('#contentModal').remove();
				});
			} else if (targetModalId === '#headerGetintouchModal') {
				eve.stopPropagation();

				if (bodyElement.classList.contains('contactopen')) {
					targetModalObj.close();
				} else {
					targetModalObj = new Dialog(
						targetModalId,
						this,
						'a',
						false,
						() => {
							// close function
							bodyElement.classList.remove('contact-showing');
							bodyElement.classList.remove('contactopen');
						},
						() => {
							// open function
							if (menubar && bodyElement.classList.contains('menuopen')) {
								menubar.close();
							}
							bodyElement.classList.add('contactopen');
							setTimeout(() => {
								bodyElement.classList.add('contact-showing');
							}, 1);
						}
					);
				}
			} else if (targetModalId === '#featuredHotelModal') {
				const relatedImageEl = featuredHotelModalContainer.querySelector('.related-image');
				const facilitiesListEl = featuredHotelModalContainer.querySelector('.facilities-list');
				const titleTextEl = featuredHotelModalContainer.querySelector('.title-text');
				const introTextEl = featuredHotelModalContainer.querySelector('.hotel-intro');
				const nearbyTextEl = featuredHotelModalContainer.querySelector('.nearby-text');

				targetModalObj = new Dialog(
					targetModalId,
					this,
					'a',
					false,
					() => {
						relatedImageEl.classList.remove('ls-is-cached', 'lazyloaded');
						relatedImageEl.classList.add('lazyload');
						relatedImageEl.setAttribute('data-src', '');
						relatedImageEl.removeAttribute('src');
						facilitiesListEl.innerHTML = '';
						titleTextEl.innerHTML = '';
						introTextEl.innerHTML = '';
						nearbyTextEl.innerHTML = '';
					},
					() => {
						fetchHotelDataResults(modalContr.dataset.hotelId).then((data) => {
							const { facilities, image, introtext, nearby, pagetitle } = data[0];

							relatedImageEl.setAttribute('data-src', image);
							facilities.forEach((facility) => {
								const liElem = document.createElement('li');
								const liIconElem = document.createElement('img');
								const liSpanElem = document.createElement('span');

								liSpanElem.innerHTML = facility.title;
								liIconElem.setAttribute('src', facility.image);

								liElem.appendChild(liIconElem);
								liElem.appendChild(liSpanElem);
								facilitiesListEl.appendChild(liElem);
							});
							titleTextEl.innerHTML = pagetitle;
							introTextEl.innerHTML = introtext;
							nearbyTextEl.innerHTML = nearby;
						});
					}
				);
			} else if (targetModalId === '#holidayOfferModal') {
				const termsTextEl = holidayOfferModalContainer.querySelector('.terms-text');

				targetModalObj = new Dialog(
					targetModalId,
					this,
					'a',
					false,
					() => {
						termsTextEl.innerHTML = '';
					},
					() => {
						const termsText = modalContr.dataset.terms;
						termsTextEl.innerHTML = termsText;
					}
				);
			} else if (targetModalId === '#headerTAMenuModal') {
				const taMenuContainerEl = taMenuModalContainer.closest('.ta-menu');

				targetModalObj = new Dialog(
					targetModalId,
					this,
					'a',
					false,
					() => {
						taMenuContainerEl.classList.remove('z-100');
					},
					() => {
						taMenuContainerEl.classList.add('z-100');
					}
				);
			} else if (targetModalId === '#blogFilterModal') {
				targetModalObj = new Dialog(targetModalId, this, 'h2');
			} else {
				targetModalObj = new Dialog(targetModalId, this, 'a');
			}

			document.onkeyup = function (event) {
				const kCode = event.which || event.keyCode;
				if (kCode === 27) {
					event.stopPropagation();
					targetModalObj.getOpenDialog.close();
				}
			};
		});
	}

	if (targetModalId === '#blogFilterModal') {
		window.addEventListener('resize', function () {
			const isModalOpen = targetModalObj.backdropNode.classList.contains('is-visible');
			if (mq.matches && targetModalObj && isModalOpen) {
				targetModalObj.close();
			}
		});
	}

	if (targetModalId === '#faqFilterModal') {
		window.addEventListener('resize', function () {
			const isModalOpen = targetModalObj.backdropNode.classList.contains('is-visible');
			if (mq.matches && targetModalObj && isModalOpen) {
				targetModalObj.close();
			}
		});
	}

	if (targetModalId === '#bookingWidgetModal') {
		window.addEventListener('resize', function () {
			const isModalOpen = targetModalObj.backdropNode.classList.contains('is-visible');
			if (largeMq.matches && targetModalObj && isModalOpen) {
				targetModalObj.close();
			}
		});
	}

	if (targetModalId === '#headerTAMenuModal') {
		window.addEventListener('resize', function () {
			if (mq.matches && targetModalObj) {
				const isModalOpen = targetModalObj.backdropNode.classList.contains('is-visible');
				if (isModalOpen) {
					targetModalObj.close();
				}
			}
		});
	}
};

openModalContrs.forEach((modalContr) => {
	initDialog(modalContr);
});

export { Dialog, targetModalObj };
